<template>
  <v-dialog
    v-model="dialogVisible"
    width="445px"
    @click:outside="close"
    data-testid="elem_u_003702"
  >
    <div
      class="dialog-content"
      data-testid="elem_u_003703"
    >
      <div
        class="btn-close-container"
        data-testid="elem_u_003704"
      >
        <button
          @click="close(false)"
          class="btn-close"
          data-testid="elem_u_003705"
        >
          <v-icon
            color="#E9E9E9"
            size="24"
            data-testid="elem_u_003706"
          >
            close
          </v-icon>
        </button>
      </div>
      <div
        class="content-wrapper"
        data-testid="elem_u_003707"
      >
        <div
          class="message"
          data-testid="elem_u_003708"
        >
          {{ errorMessage }}
        </div>
        <UnzipButton
          class="btn-ok"
          @click="close"
          type="secondary"
          height="40px"
          width="100%"
          data-testid="elem_u_003709"
        >
          <span data-testid="elem_u_003710"> OK </span>
        </UnzipButton>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      errorMessage: '',
    };
  },
  methods: {
    open(message) {
      this.errorMessage = message;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  background: var(--color-grey-280);
  position: relative;
  padding: 15px;

  .btn-close-container {
    display: flex;
    width: 100%;
    height: fit-content;
    margin-bottom: 10px;
  }
  .btn-close {
    height: 24px;
    width: 24px;
    margin-left: auto;
    display: flex;
  }
  .content-wrapper {
    padding: 0 35px 35px 35px;

    @include sm-down {
      padding: 0 5px 15px;
    }
  }
  .message {
    color: var(--color-grey-900);
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    line-height: 26px;
  }
  .btn-ok {
    margin-top: 30px;
  }
}
</style>
